import { h, render } from 'preact';
import { useEffect, useState } from 'preact/hooks';
import { isBrowserIE, installPolyfills } from 'polyfills/helpers';
import { enableES5 } from 'immer';
import { handleFirstTab, handleMouseClick } from 'widget_main/globals/helpers';

import App from './app';
import './styles/base.scss';

if (isBrowserIE()) {
  enableES5();
}

const Root = () => {
  const [polyfillsLoaded, updatePolyfillsLoaded] = useState(false);

  useEffect(() => {
    window.addEventListener('keydown', handleFirstTab);

    installPolyfills().then(() => {
      updatePolyfillsLoaded(true);
    });

    return () => {
      window.removeEventListener('keydown', handleFirstTab);
      window.removeEventListener('mousedown', handleMouseClick);
    };
  }, []);

  const renderApp = () => {
    if (polyfillsLoaded) {
      return <App />;
    }
    return null;
  };

  return renderApp();
};

render(<Root />, document.getElementById('root') as HTMLElement);
